<template>
  <v-container id="recognition" fluid tag="section">
    <v-row>
      <router-view :key="$route.path" />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Recognition",
  data() {
    return {};
  },
};
</script>
